/**
 * Controllers classes defined for this app
 */
import { ModalAddLinks, ModalVariant } from "@3cad/nextcore";

export class V_ModalVarsResolver extends ModalVariant {
    options = {
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        hideHeaderClose: true
    };

    constructor(modalRef, options = {}) {
        super(modalRef);
        Object.assign(this.options, options);
    }

    /** Open application modal to resolve variants
     * @param variant
     * @param rule
     * @param catalog
     * @return {Promise<any>}
     */
    open(variant, rule, catalog) {
        return new Promise((resolve, reject) => {
            this.modal({
                // title: Dau.T('Set variant') + ': <span class="text-info">' + variant.des +'</span>',
                title: 'Set variant: <span class="text-info">' + variant.des + "</span>",
                noCloseOnBackdrop: true,
                // noCloseOnEsc: true,
                // hideHeaderClose: true,
                params: variant,
                catalog: catalog,
                extra: {
                    model: rule.model || "",
                    neutro: rule.neutro || "",
                    item: rule.item || "",
                    cModel: rule.cModel || "",
                    reg: rule.reg || ""
                }
            })
                .then(resolve)
                .catch(reject);
        });
    }
}

export class V_ModalPopVar extends ModalVariant {
    options = {};

    constructor(modalRef, options = {}) {
        super(modalRef);
        this.options = options;
    }

    /** Open application modal to resolve variants
     * @param variant
     * @param rule
     * @param catalog
     * @return {Promise<any>}
     */
    open(variant, rule, catalog) {
        return new Promise((resolve, reject) => {
            let params = {
                // title: 'Set variant: <span class="text-info">' + variant.des +'</span>',
                params: variant,
                catalog: catalog,
                extra: {
                    model: rule.model || "",
                    neutro: rule.neutro || "",
                    item: rule.item || "",
                    cModel: rule.cModel || "",
                    reg: rule.reg || ""
                }
            };

            Object.assign(this.options, params);

            this.modal(this.options).then(resolve).catch(reject);
        });
    }

    setModalOptions(options) {
        this.options = options;
    }
}

export class V_ModalDClass extends ModalVariant {
    options = {};
    dClassesObj = null;

    constructor(modalRef, options = {}, dClassesConfigObj) {
        super(modalRef);
        this.options = options;
        this.dClassesObj = dClassesConfigObj;
    }

    /** Open application modal to resolve variants
     * @param variant
     * @param rule
     * @param catalog
     * @return {Promise<any>}
     */
    open(variant, rule, catalog) {
        let dclassRef = variant.classe.ex("||", 1).toLowerCase();

        if (!dclassRef) throw "This variable is not a dClass";

        let dClass = this.dClassesObj[dclassRef];

        if (!dClass) throw "dClass is not declared in configuration file";

        let params = {
            dclass: dClass.comp,
            title: dClass.name,
            variant: variant,
            catalog: catalog,
            extra: {
                model: rule.model || "",
                neutro: rule.neutro || "",
                item: rule.item || "",
                cModel: rule.cModel || "",
                reg: rule.reg || ""
            }
        };

        Object.assign(this.options, params);

        return new Promise((resolve, reject) => {
            this.modal(this.options).then(resolve).catch(reject);
        });
    }

    setModalOptions(options) {
        this.options = options;
    }
}

export class V_ModalAddLinks extends ModalAddLinks {
    constructor(modalRef, options) {
        super(modalRef);
        this.options = options;
    }

    open(addLinksData) {
        return new Promise((resolve, reject) => {
            if (this.options && this.options.componentData.data) {
                this.options.componentData.data = addLinksData;
            }
            this.modal(this.options).then(resolve).catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/vue.controllers/controllers.js